import { Box, Button } from '@mui/material';
import { brandColors } from 'types/colors';

const ComfortSelector = ({ value, onChange }) => {
  const options = ['Cool', 'Neutral', 'Cozy'];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 'fit-content', gap: 0.5, ml: 1.5 }}>
      {options.map(option => (
        <Button
          key={option}
          variant="inherit"
          onClick={() => onChange(option)}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            width: '2rem',
            minWidth: '3.4rem',
            height: '2.2rem',
            borderColor: brandColors.GREY_DARK,
            color: value === option ? '#fff' : brandColors.GREY_DARK,
            backgroundColor: value === option ? brandColors.BLUE : 'transparent',
            border: `1px solid ${brandColors.GREY_DARK}`,
            '&:hover': {
              backgroundColor: brandColors.BLUE,
              color: '#fff',
              // borderColor: brandColors.GREY_DARK,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.32)',
            },
          }}>
          {option}
        </Button>
      ))}
    </Box>
  );
};
export default ComfortSelector;
